import { FC } from 'react';
import Video from 'react-scale/components/elements/video';
import type { HeroDefaultProps } from '.';

export type HeroWithVideo = {
  video: {
    src: string;
    poster?: string;
    width: number;
    height: number;
    frame?: boolean;
    autoplay?: boolean;
    loop?: boolean;
    muted?: boolean;
    controls?: boolean;
  };
  image: never;
  scene: never;
  content: never;
} & HeroDefaultProps;

const VideoAsset: FC<HeroWithVideo['video']> = ({
  src,
  poster,
  width = 1920,
  height = 1080,
  frame = false,
  autoplay = true,
  controls = false,
  loop = true,
  muted = true
}) => {
  return (
    <div className="flex items-center justify-center lg:w-full my-14 lg:my-0">
      <div className="relative w-full">
        {frame ? (
          <div className="p-4 bg-white bg-opacity-20 rounded-2xl backdrop-blur">
            <Video
              // @ts-ignore: Unreachable code error
              url={src}
              width={width}
              height={height}
              loop={loop}
              playing={autoplay}
              playsinline={autoplay}
              controls={controls}
              poster={poster}
              muted={muted}
              blackButton
              smallButton
            />
          </div>
        ) : (
          <Video
            // @ts-ignore: Unreachable code error
            url={src}
            width={width}
            height={height}
            loop={loop}
            playing={autoplay}
            playsinline={autoplay}
            controls={controls}
            poster={poster}
            muted={muted}
            blackButton
            smallButton
          />
        )}
      </div>
    </div>
  );
};

export default VideoAsset;
